import React from "react";
import { withCookies } from "react-cookie";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import PdfEditArticleAVList from "../PdfEditArticleAVList/PdfEditArticleAVList";
import "./WebEditArticleContainer.css";
import WebEditArticleImageList from "../WebEditArticleImageList/WebEditArticleImageList";

class WebEditArticleContainer extends React.Component {
  renderImagePart() {
    const { article, issue } = this.props;

    return <WebEditArticleImageList article={article} issue={issue} />;
  }

  renderAVPart() {
    const { article } = this.props;

    return <PdfEditArticleAVList article={article} isPdf={false} />;
  }

  render() {
    return (
      <React.Fragment>
        <Tabs transition={false}>
          <Tab eventKey="image" title="Image">
            {this.renderImagePart()}
          </Tab>

          <Tab eventKey="av" title="AV">
            {this.renderAVPart()}
          </Tab>
        </Tabs>
      </React.Fragment>
    );
  }
}

export default withCookies(WebEditArticleContainer);
